// extracted by mini-css-extract-plugin
module.exports = {"craftWelcomeMessageForm":"EditSendMessageActionForm_craftWelcomeMessageForm___9rRO"};